import { Component, inject } from '@angular/core';
import { AppInformationService } from 'app/core/app-information.service';
import { AuthService, GenesisUnitOfWork } from 'app/core/core.module';
import { Contact } from 'app/core/model/contact';
import { ContactRole } from 'app/core/model/contact-role';
import { SelectionChangedEvent } from 'devextreme/ui/select_box';
import validationEngine from 'devextreme/ui/validation_engine';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-contact-dialog',
    template: `
        <div class="modal-header">
            <h2 class="modal-title">Contact</h2>
        </div>
        <div class="modal-body">
            <dx-form [formData]="contact" validationGroup="contactValidationGroup" *ngIf="contact">
                <dxi-item dataField="name" [isRequired]="true"></dxi-item>
                <dxi-item dataField="phone"></dxi-item>
                <dxi-item dataField="email"></dxi-item>
                <dxi-item
                    dataField="roleId"
                    editorType="dxSelectBox"
                    [editorOptions]="{ items: contactRoles, valueExpr: 'id', displayExpr: 'name', onSelectionChanged: roleSelectionChanged }"
                    [label]="{ text: 'Role' }"
                    [isRequired]="true"
                ></dxi-item>
                <dxi-item dataField="otherRole" [visible]="contact?.roleId === roles.Other" [isRequired]="true"></dxi-item>
                <dxi-item dataField="notes" editorType="dxTextArea" [editorOptions]="{ height: '125px' }"></dxi-item>
            </dx-form>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-success" (click)="save()">Save</button>
            <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
        </div>
    `,
    styles: [],
    standalone: false
})
export class ContactDialogComponent {
    appInfo = inject(AppInformationService);
    uow = inject(GenesisUnitOfWork);
    auth = inject(AuthService);

    result = new Subject<{ success: boolean; value?: Contact }>();
    contact: Contact;
    entityId: number;
    entityType: 'Dealer' | 'Vendor';
    contactRoles: ContactRole[];
    roles = ContactRole.Roles;

    async ngOnInit() {
        this.contactRoles = await this.uow.contactRoles.whereActive('displayOrder, name');
        await this.getData();
    }

    async getData() {
        if (!this.contact) {
            this.contact = this.uow.contacts.createEntity({
                roleId: null,
                created: new Date(),
                createdBy: this.auth.currentUser.userName,
            });
            if (this.entityType === 'Dealer') this.contact.dealerId = this.entityId;
            else if (this.entityType === 'Vendor') this.contact.vendorId = this.entityId;
        }
    }

    roleSelectionChanged = (e: SelectionChangedEvent) => {
        if (e.selectedItem?.id !== ContactRole.Roles.Other) this.contact.otherRole = null;
    };

    async save() {
        if (!this.validate()) return;
        this.result.next({ success: true, value: this.contact });
    }

    cancel() {
        this.contact.entityAspect.rejectChanges();
        this.result.next({ success: false });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig('contactValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('contactValidationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
